import LocalizedStrings from 'localized-strings';

import { ApplicantType } from 'features/Onboarding/types';

export default new LocalizedStrings({
  en: {
    ownershipClickHere: 'Click here',
    ownershipOtherCompanyLink: {
      [ApplicantType.AccountHolder]:
        'Your company is partially owned by another company?',
      [ApplicantType.Mandatee]:
        'The company is partially owned by another company?',
    },
  },
  fr: {
    ownershipClickHere: 'Cliquez ici',
    ownershipOtherCompanyLink: {
      [ApplicantType.AccountHolder]:
        'Une autre société détient des parts de votre société\u00A0?',
      [ApplicantType.Mandatee]:
        'Une autre société détient des parts de la société\u00A0?',
    },
  },
} as const);
